import React from 'react';
import { Navigate } from 'react-router-dom';
import Flex from '../../../components/Flex';
import { useSelector } from 'react-redux';
import {
  getProject,
  getProjectRedirect,
  RootReducerState,
} from '../../../apps/main/rootReducer';
import { Project } from '../../../models/Project';
import { makePrioStyles } from '../../../theme/utils';
import PrioSpinner from '../../../components/PrioSpinner';
import { ProjectId } from '../../../models/Types';
import Dashboard from '../../dashboard/components/Dashboard';

const useStyles = makePrioStyles((theme) => ({
  root: {
    position: 'relative',
    height: '100%',
  },
  body: {
    overflow: 'hidden',
  },
}));

interface ProjectSummaryProps {
  projectId: ProjectId;
  isProjectMember?: boolean;
}

export const ProjectSummary: React.FC<ProjectSummaryProps> = (props) => {
  const { projectId, isProjectMember } = props;
  const classes = useStyles();

  const project = useSelector<RootReducerState, Project>((state) =>
    getProject(state, projectId)
  );

  const redirect = useSelector<RootReducerState, string>((state) =>
    getProjectRedirect(state, projectId)
  );

  if (redirect) {
    return <Navigate to={`../../${redirect}/summary`} />;
  }

  if (!project) {
    return (
      <Flex.Column className={classes.root}>
        <div className="prio-flex-center-center prio-flex-column prio-container-fullscreen-height">
          <PrioSpinner size="large" />
        </div>
      </Flex.Column>
    );
  }

  return (
    <Flex.Column className={classes.root}>
      {
        <Dashboard
          projectId={projectId}
          key={projectId}
          isPojectMember={isProjectMember}
        />
      }
    </Flex.Column>
  );
};

export default ProjectSummary;
